{
  let startOverrideIntervalId;
  let bzBtnLoaderIntervalId;
  let ghostMode = null;
  let checkoutSelector = null;
  let buyNowSelector = null;

  async function getCart() {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data && data["items"] !== null) {
        return data.items.length;
      }
  	} catch (e) {
      customLogger("Get cart failed: " + e);
  	}
  	return null;
  }
  function openCheckout(retries, callback, event) {
  	try {
      const interval = setInterval(async function () {
        retries = retries - 1;
        console.log("openCheckout polling cart... >>>");
        const cartItems = await getCartItems(); // Use the full cart items
        const items = cartItems.length;

        if (items !== null && items > 0) {
          const containsVroomVroomSweater = cartItems.some(
            (item) =>
              item.product_title.toLowerCase().includes("vroom vroom sweater")
          );
          console.log(
          	"openCheckout Vroom Vroom Sweater check:",
          	containsVroomVroomSweater,
          	">>>"
          );

          if (containsVroomVroomSweater) {
          	console.log("Redirecting to Shopify Checkout (Fallback) >>>");
          	window.location.href = "/checkout";
          } else {
          	console.log("Proceeding with Breeze checkout (Fallback) >>>");
          	callback(); // This is breeze.startCheckout
          }

          clearInterval(interval);
          closePopups();
        }
        if (retries == 0) {
          clearInterval(interval);
          handleButtonOverrideFailure(event);
        }
      }, 1000);
  	} catch (e) {
      customLogger("Checkout opening failed: " + e);
      handleButtonOverrideFailure(event);
  	}
  }
  function expireCartCookie() {
  	try {
      const date = new Date();
      date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toString();
      document.cookie = "cart" + "=" + expires + "; path=/";
  	} catch (e) {
      customLogger("Failed to clear the cookie: " + e);
  	}
  }

  function addSampleBreezeTag() {
  	try {
      const newDiv = document.createElement("breeze-button");
      newDiv.style.display = "none";
      document.body.appendChild(newDiv);
  	} catch (e) {
      customLogger("Error in addSampleBreezeTag: " + e);
  	}
  }
  function startOverride() {
  	try {
      const bzGhostMode = window.bzGhostMode ?? null;
      if (bzGhostMode !== null) {
        startOverrideIntervalId.clear();
        if (bzGhostMode === true && ghostMode !== "samurai") {
        	return;
        }
        bzBtnLoaderIntervalId = setIntervalExponential(
        	addBreezeCheckout,
        	5,
        	2,
        	10000
        );
      }
  	} catch (e) {
      customLogger("Error in startOverride: " + e);
  	}
  }

  function getAddToCartButton(containerElement = null) {
  	const selectorArr = [
      "button[class*='product-form__submit']",
      "button[class*='add-to-cart']",
  	];
  	if (
      typeof window.addToCartSelector === "string" &&
      window.addToCartSelector !== ""
  	) {
      selectorArr.push(window.addToCartSelector);
  	}
  	const selector = selectorArr.join(",");
  	return getNativeButtons(selector, containerElement);
  }

  function addBreezeCheckout() {
  	try {
      addSampleBreezeTag();
      const isBreezeAvailable =
      	window.breeze !== undefined && window.breeze !== null;
      if (!isBreezeAvailable) {
      	customLogger("Breeze is not available.");
      	return;
      }
      customLogger("Breeze is available");
      bzBtnLoaderIntervalId.clear();
      createButtonSelectors();
      document.addEventListener("click", documentClickListener, true);
      if (window.bzInternationalConfig?.enable === true) {
      	removeBreezeIfUnsupportedCountry();
      }
  	} catch (e) {
      customLogger("Error in addBreezeCheckout: " + e);
      handleButtonOverrideFailure();
  	}
  }

  async function documentClickListener(e) {
  	console.log("Document click intercepted >>>", e.target);
  	const target = e.target;
  	let checkoutButton = null;
  	let buyNowButton = null;
  	const composedPath = event.composedPath();
  	const isUpcartButtonClicked = composedPath?.[0]?.classList?.contains(
      "upcart-checkout-button"
  	);
  	if (checkoutSelector !== null && checkoutSelector !== "") {
      checkoutButton = target.closest(checkoutSelector);
  	}
  	if (buyNowSelector !== null && buyNowSelector !== "") {
      buyNowButton = target.closest(buyNowSelector);
  	}
  	if (checkoutButton instanceof HTMLElement || isUpcartButtonClicked) {
      console.log("Checkout button clicked >>>");
      // addButtonLoader(checkoutButton);
      await handleCheckoutEvent(e);
      // removeButtonLoader(checkoutButton);
      return;
  	} else if (buyNowButton instanceof HTMLElement) {
      console.log("Buy Now button clicked >>>");
      addButtonLoader(buyNowButton);
      await handleBuyNowEvent(e);
      removeButtonLoader(buyNowButton);
  	}
  }
  // build your set product handling
  //fetch cart items
  async function getCartItems() {
  	console.log("getCartItems started >>>");
  	try {
      const response = await fetch("/cart.js", {
      	method: "GET",
      	headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      console.log("getCartItems response data >>>", data);
      return data.items || [];
  	} catch (e) {
      console.error("Get cart failed:", e);
      return [];
  	}
  }
  // redirection
  async function handleCheckoutEvent(event) {
  	console.log("handleCheckoutEvent started >>>");
  	try {
      event.preventDefault();
      event.stopImmediatePropagation();

      const cartItems = await getCartItems();
      console.log("Cart items for checkout:", cartItems, ">>>");

      const containsVroomVroomSweater = cartItems.some(
      	(item) =>
        	item.product_title.toLowerCase().includes("vroom vroom sweater")
      );
      console.log(
      	"Vroom Vroom Sweater check:",
      	containsVroomVroomSweater,
      	">>>"
      );

      if (containsVroomVroomSweater) {
      	console.log("Redirecting to native checkout for Vroom Vroom >>>");
      	window.location.href = "/checkout";
      	return;
      }

      // Proceed with Breeze Checkout
      console.log("Proceeding with Breeze checkout >>>");
      const breeze = window.breeze;
      if (breeze && typeof breeze.startCheckout === "function") {
      	if (window.bzEmbraceNotesUpdate === true) {
      	  await updateNotesAttributeToCart();
      	}
      	breeze.startCheckout();
      } else {
      	console.error(
      	"Breeze checkout function is not available >>>"
      	);
      	handleButtonOverrideFailure(event);
      }
  	} catch (e) {
      console.error("Error in handleCheckoutEvent:", e, ">>>");
      handleButtonOverrideFailure(event);
  	}
  }
  // async function handleCheckoutEvent(event) {
  //   try {
  //     event.preventDefault();
  //     event.stopImmediatePropagation();

  //     const breeze = window.breeze;
  //     if (breeze && typeof breeze.startCheckout === "function") {
  //       if (window.bzEmbraceNotesUpdate === true) {
  //         await updateNotesAttributeToCart();
  //       }
  //       breeze.startCheckout();
  //     } else {
  //       customLogger("Breeze checkout function is not available");
  //       handleButtonOverrideFailure(event);
  //     }
  //   } catch (e) {
  //     customLogger("Error in handleCheckoutEvent: " + e);
  //     handleButtonOverrideFailure(event);
  //   }
  // }
  async function handleBuyNowEvent(event) {
  	console.log("handleBuyNowEvent started >>>");
  	try {
      event.preventDefault();
      event.stopImmediatePropagation();
      const startCheckout = window.breeze?.startCheckout;
      if (startCheckout && typeof startCheckout === "function") {
      	expireCartCookie();
      	console.log("Clearing cart for Buy Now >>>");
      	await fetch("/cart/clear.js", {
      	  method: "POST",
      	  headers: { "Content-Type": "application/json" },
      	  body: "{}",
      	});
      	await addProductToCartAndCheckout(event, startCheckout);
      } else {
      	customLogger("Breeze checkout function is not available");
      	handleButtonOverrideFailure(event);
      }
  	} catch (e) {
      customLogger(`Error in handleBuyNowEvent: ${e}`);
      handleButtonOverrideFailure(event);
  	}
  }

  async function addProductToCartAndCheckout(event, startCheckout) {
  	console.log("addProductToCartAndCheckout started >>>");
  	let isProductAddedToCart = false;
  	const target = event.target;
  	if (target instanceof HTMLElement) {
      const productForm = target.closest(
      	"form[method='post'][action*='/cart/add']"
      );
      if (productForm instanceof HTMLFormElement) {
      	const formData = new FormData(productForm);
      	try {
      	  const response = await fetch("/cart/add.js", {
      	  	method: "POST",
      	  	body: formData,
      	  });
      	  if (response.status === 200) {
      	  	isProductAddedToCart = true;
      	  	const data = await response.json();
      	  	console.log("Product added, response data:", data, ">>>");

      	  	const isVroomVroomSweater =
      	  	  data?.product_title?.toLowerCase().includes("vroom vroom sweater");
      	  	console.log(
      	  	  "Buy Now Vroom Vroom Sweater check:",
        	  	  isVroomVroomSweater,
        	  	  ">>>"
        	  	);

        	  	if (isVroomVroomSweater) {
        	  	  console.log(
        	  	  	"Redirecting to native checkout for Vroom Vroom (Buy Now) >>>"
        	  	  );
        	  	  window.location.href = "/checkout";
        	  	} else {
        	  	  console.log("Proceeding with Breeze checkout (Buy Now) >>>");
        	  	  startCheckout(); // Original behavior
        	  	}
        	  	// END MODIFIED LOGIC

        	  	customLogger(
        	  	  `Product added to cart successfully: ${JSON.stringify(data)}`
        	  	);
        	  }
        	} catch (error) {
        	  customLogger(`Error while adding product to cart: ${error}`);
        	}
        }
  	}
  	if (!isProductAddedToCart) {
    	console.log("Product not added via fetch, trying fallback >>>");
    	const retry = window.checkoutOpenRetry || 10;
    	const addToCartButton = getAddToCartButton();
    	clickAddToCartBtn(event, addToCartButton);
    	openCheckout(retry, startCheckout, event);
  	}
  }

  function clickAddToCartBtn(event, addToCartButtons) {
  	if (addToCartButtons.length === 0) {
    	customLogger("Error: No add to cart button found");
    	handleButtonOverrideFailure(event);
  	} else if (addToCartButtons.length === 1) {
    	addToCartButtons[0].click();
  	} else {
    	// getting addToCart button nearest to buy now button
    	let attemptCount = 0;
    	const maxAttempts = 50;
    	let currentElement = event.target;
    	while (currentElement && attemptCount < maxAttempts) {
      	const buttons = getAddToCartButton(currentElement);
      	if (buttons.length !== 0) {
      	  buttons[0].click();
      	  return;
      	}
      	currentElement = currentElement.parentElement;
      	attemptCount++;
    	}
    	customLogger("Error: unable to find nearest add to cart button");
    	handleButtonOverrideFailure(event);
  	}
  }

  function closePopups() {
  	try {
      if (
      	typeof window.bzPopupCloseSelector === "string" &&
      	window.bzPopupCloseSelector !== ""
      ) {
      	const miniCartCloseBtn = getNativeButtons(window.bzPopupCloseSelector);
      	miniCartCloseBtn.forEach((btn) => btn.click());
      }
  	} catch (error) {
      customLogger(`Error: unable to close mini cart popup: ${error}`);
  	}
  }

  async function updateNotesAttributeToCart() {
  	let notesValue = null;
  	try {
      const noteElement = document.querySelector("textarea[name*=note]");
      if (noteElement instanceof HTMLTextAreaElement) {
      	notesValue = noteElement.value.trim();
      }
      if (notesValue !== null) {
      	const response = await fetch(`/cart/update.js`, {
      	  method: "POST",
      	  headers: { "Content-Type": "application/json" },
      	  body: JSON.stringify({ note: notesValue }),
      	});
      	if (response.status !== 200) {
      	  throw new Error("Unable to update notes, api response failure");
      	}
      } else {
      	throw new Error("Unable to get notes from page");
      }
  	} catch (error) {
      customLogger(`Error|updateNotesAttributeToCart|${error}`);
  	}
  }

  function addButtonLoader(button) {
  	button.style.opacity = "0.5";
  	if (
      button instanceof HTMLInputElement ||
      button instanceof HTMLButtonElement
  	) {
      button.disabled = true;
  	} else {
      button.style.pointerEvents = "none";
      button.style.cursor = "not-allowed";
  	}
  }
  function removeButtonLoader(button) {
  	button.style.opacity = "";
  	if (
      button instanceof HTMLInputElement ||
      button instanceof HTMLButtonElement
  	) {
      button.disabled = false;
  	} else {
      button.style.pointerEvents = "";
      button.style.cursor = "";
  	}
  }

  function createButtonSelectors() {
  	checkoutSelector =
      typeof window.checkoutSelector === "string" &&
      window.checkoutSelector !== ""
      	? window.checkoutSelector
      	: "button[name='checkout'],a[href='/checkout']";
  	buyNowSelector =
      typeof window.buyNowSelector === "string" && window.buyNowSelector !== ""
      	? window.buyNowSelector
      	: "div.shopify-payment-button";
  }

  // utils
  function getNativeButtons(selector, containerElement = null) {
  	let buttons = [];
  	try {
      if (selector !== "") {
      	if (containerElement !== null) {
      	  buttons = Array.from(containerElement.querySelectorAll(selector));
      	} else {
      	  buttons = Array.from(document.querySelectorAll(selector));
      	}
      }
  	} catch (e) {
      customLogger(`Error in getNativeButtons: ${e}`);
  	}
  	return buttons;
  }

  function customLogger(message) {
  	if (ghostMode === "samurai") {
      console.log(`BZ|${message}`);
  	}
  }
  // script start point
  try {
  	customLogger("FunctionCalled with setIntervalExponential | startOverride");
  	ghostMode = window.localStorage.getItem("ghost");
  	startOverrideIntervalId = setIntervalExponential(startOverride, 5, 2);
  } catch (e) {
  	customLogger("Error starting the override process: " + e);
  	handleButtonOverrideFailure();
  }

  // IP based routing
  async function removeBreezeIfUnsupportedCountry() {
  	if (typeof window.bzInternationalConfig !== "undefined") {
      const supportedCountryCode = Array.isArray(
      	window.bzInternationalConfig.supportedCountryCode
      )
      	? window.bzInternationalConfig.supportedCountryCode
      	: [];
      supportedCountryCode.push("IN"); // by default India is supported
      try {
      	const response = await fetch("https://ipinfo.io/json");
      	const result = await response.json();
      	if (
      	  typeof result === "object" &&
      	  !Array.isArray(result) &&
      	  result.country &&
      	  !supportedCountryCode.includes(result.country)
      	) {
      	  removeButtonOverriding();
      	}
      } catch (error) {
      	customLogger(`Error fetching IP location: ${error}`);
      }
  	}
  }

  function setIntervalExponential(callback, initialDelay, factor, maxDelay) {
  	let currentDelay = initialDelay;
  	let timeoutId = null;
  	let isCleared = false;

  	function executeCallback() {
      if (isCleared === false) {
      	callback();
      	currentDelay *= factor;
      	if (currentDelay <= 0) {
      	  currentDelay = 1;
      	}
      	if (maxDelay !== undefined && currentDelay > maxDelay) {
      	  currentDelay = maxDelay;
      	}
      	timeoutId = setTimeout(executeCallback, currentDelay);
      }
  	}

  	timeoutId = setTimeout(executeCallback, currentDelay);

  	return {
      clear: () => {
      	if (timeoutId) {
      	  clearTimeout(timeoutId);
      	  isCleared = true;
      	}
      },
  	};
  }

  function handleButtonOverrideFailure(event = null) {
  	try {
      console.log("handleButtonOverrideFailure triggered >>>");
      customLogger("FunctionCalled | handleButtonOverrideFailure");
      removeButtonOverriding();
      if (event !== null && event.target !== null) {
      	const targetElement = event.target;
      	if (typeof targetElement.click === "function") {
      	  targetElement.click();
      	}
      }
  	} catch (error) {
      customLogger(`Error in handleButtonOverrideFailure: ${error}`);
  	}
  }

  function removeButtonOverriding() {
  	document.removeEventListener("click", documentClickListener, true);
  }
}